import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center",
  style: {"width":"111px"}
}
const _hoisted_2 = ["disabled", "onClick"]
const _hoisted_3 = { class: "svg-icon svg-icon-3" }
const _hoisted_4 = ["disabled", "onClick"]
const _hoisted_5 = { class: "svg-icon svg-icon-3" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick", "data-bs-toggle", "data-bs-target", "innerHTML"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { colspan: "100%" }
const _hoisted_13 = { class: "table table-bordered table-sm w-100 bg-light" }
const _hoisted_14 = ["onClick", "data-bs-toggle", "data-bs-target", "innerHTML"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_ActionsCell = _resolveComponent("ActionsCell")!

  return (_openBlock(), _createElementBlock("tbody", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, idx) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
        _createElementVNode("tr", null, [
          (_ctx.mapping.updateOrder)
            ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
                _createElementVNode("button", {
                  class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                  disabled: idx === 0,
                  onClick: ($event: any) => (_ctx.$emit('move-up', idx)),
                  title: "Move up"
                }, [
                  _createElementVNode("span", _hoisted_3, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr062.svg" })
                  ])
                ], 8, _hoisted_2),
                _createElementVNode("button", {
                  class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                  disabled: idx === _ctx.items.length - 1,
                  onClick: ($event: any) => (_ctx.$emit('move-down', idx)),
                  title: "Move down"
                }, [
                  _createElementVNode("span", _hoisted_5, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr065.svg" })
                  ])
                ], 8, _hoisted_4)
              ]))
            : _createCommentVNode("", true),
          (_ctx.mapping.ShowInnerRows)
            ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
                _createElementVNode("button", {
                  class: "btn btn-icon btn-sm",
                  onClick: ($event: any) => (_ctx.toggle(item[_ctx.mapping.PrimaryKey]))
                }, [
                  _createVNode(_component_inline_svg, {
                    src: _ctx.isExpanded(item) ? '/media/icons/duotune/arrows/arr082.svg' : '/media/icons/duotune/arrows/arr081.svg'
                  }, null, 8, ["src"])
                ], 8, _hoisted_7)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mapping.Columns, (col, k) => {
            return (_openBlock(), _createElementBlock("td", { key: k }, [
              (_ctx.isRenderable(col))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass({ clickable: !!col.click }),
                    onClick: ($event: any) => (_ctx.handleClick(col, item)),
                    "data-bs-toggle": col.click ? 'modal' : '',
                    "data-bs-target": col.click ? '#kt_modal_new_card_' + _ctx.routeKey : '',
                    innerHTML: col.format ? col.format(item) : item[col.name]
                  }, null, 10, _hoisted_8))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_ctx.pagination)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString((parseInt(_ctx.pagination.currentPage) - 1) * parseInt(_ctx.pagination.paginate) +
                parseInt(idx) + 1), 1))
                      : _createCommentVNode("", true)
                  ]))
            ]))
          }), 128)),
          (_ctx.hasActions)
            ? (_openBlock(), _createBlock(_component_ActionsCell, {
                key: 2,
                mapping: _ctx.mapping,
                item: item,
                "route-key": _ctx.routeKey,
                onOpenModal: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open-modal', $event))),
                onDelete: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('delete', $event))),
                onRowAction: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('row-action', $event)))
              }, null, 8, ["mapping", "item", "route-key"]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.mapping.ShowInnerRows && _ctx.expandedId === item[_ctx.mapping.PrimaryKey])
          ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
              _createElementVNode("td", _hoisted_12, [
                _createElementVNode("table", _hoisted_13, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mapping.InnerColumn.columns, (col, i) => {
                        return (_openBlock(), _createElementBlock("th", {
                          key: 'inner-th-' + i
                        }, _toDisplayString(col.label), 1))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item[_ctx.mapping.InnerColumn.key], (nested, j) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: 'nested-' + j
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mapping.InnerColumn.columns, (col, k) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: 'nested-td-' + k,
                            class: _normalizeClass(col.type)
                          }, [
                            (_ctx.isRenderable(col))
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass({ clickable: !!col.click }),
                                  onClick: ($event: any) => (_ctx.handleInnerClick(col, item)),
                                  "data-bs-toggle": col.click ? 'modal' : '',
                                  "data-bs-target": col.click ? '#kt_modal_new_card_' + _ctx.routeKey : '',
                                  innerHTML: col.format ? col.format(nested) : item[col.name]
                                }, null, 10, _hoisted_14))
                              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  (_ctx.pagination)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString((parseInt(_ctx.pagination.currentPage) - 1) * parseInt(_ctx.pagination.paginate) +
                        parseInt(j) + 1), 1))
                                    : _createCommentVNode("", true)
                                ]))
                          ], 2))
                        }), 128))
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}